export default {"src":"/seller-forums/_next/static/media/quote.ed5a3dae.svg","height":7,"width":10};